import React, { ReactNode } from "react";
import cn from "classnames";

import { useInRouteDrawer } from "Components/RouteDrawer/RouteDrawerContext";

import styles from "./Block.module.scss";

type BlockProps = {
  children: ReactNode;
  className?: string;
  padding?: string;
  mr?: number;
  mt?: number;
  mb?: number;
  ml?: number;
  zIndex?: number;
  isBlur?: boolean;
  isBorder?: boolean;
  onClick?: () => void;
};

const Block: React.FC<BlockProps> = ({
  children,
  mr,
  mt,
  mb,
  ml,
  className,
  zIndex,
  isBlur,
  isBorder,
  onClick,
  padding,
}) => {
  const inDrawer = useInRouteDrawer();
  return (
    <div
      className={cn(
        styles.block,
        inDrawer && styles.block_flat,
        isBlur && styles.block_blur,
        className,
      )}
      onClick={onClick}
      style={{
        marginBottom: `${mb}px`,
        marginTop: `${mt}px`,
        marginLeft: `${ml}px`,
        marginRight: `${mr}px`,
        padding: padding,
        zIndex: zIndex,
      }}
    >
      {children}
    </div>
  );
};
export default Block;
